var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    line = _require$doc$builders.line;

var LabelDefinition = {
  print: function print(_ref) {
    var node = _ref.node;
    return concat([node.name, ':', line]);
  }
};
module.exports = LabelDefinition;